import React from "react";
import Check from "./check.svg";

import "./styles.scss";

export interface IChecklistProps {
    bullets?: string[];
  }
export const Checklist = ({ bullets }: IChecklistProps) => (
  <ul className="checklist__bullet__list">
    {bullets && bullets.map((bullet, index) => (
      <li key={index} className="checklist__bullet">
        <img src={Check} alt="check icon" />
        {bullet}
      </li>
    ))}
  </ul>
);
